var _g, _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2229_7994)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_2229_7994",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.16602 0C2.61373 0 2.16602 0.447715 2.16602 1V31C2.16602 31.5523 2.61373 32 3.16601 32H27.8327C28.385 32 28.8327 31.5523 28.8327 31L28.8327 5.33333L23.4994 0H3.16602Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.16602 0C2.61373 0 2.16602 0.447715 2.16602 1V31C2.16602 31.5523 2.61373 32 3.16601 32H27.8327C28.385 32 28.8327 31.5523 28.8327 31L28.8327 5.33333L23.4994 0H3.16602Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8327 31H28.3327H28.8327ZM28.8327 5.33333H29.3327V5.12623L29.1862 4.97978L28.8327 5.33333ZM23.4994 0L23.8529 -0.353553L23.7065 -0.5H23.4994V0ZM2.66602 1C2.66602 0.723858 2.88987 0.5 3.16602 0.5V-0.5C2.33759 -0.5 1.66602 0.171573 1.66602 1H2.66602ZM2.66602 31V1H1.66602V31H2.66602ZM3.16601 31.5C2.88987 31.5 2.66602 31.2761 2.66602 31H1.66602C1.66602 31.8284 2.33759 32.5 3.16601 32.5V31.5ZM27.8327 31.5H3.16601V32.5H27.8327V31.5ZM28.3327 31C28.3327 31.2761 28.1088 31.5 27.8327 31.5V32.5C28.6611 32.5 29.3327 31.8284 29.3327 31H28.3327ZM28.3327 5.33333L28.3327 31H29.3327L29.3327 5.33333H28.3327ZM29.1862 4.97978L23.8529 -0.353553L23.1458 0.353553L28.4791 5.68689L29.1862 4.97978ZM3.16602 0.5H23.4994V-0.5H3.16602V0.5Z",
    fill: "#A3B2C7",
    fillOpacity: 0.28,
    mask: "url(#path-1-inside-1_2229_7994)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8324 5.33333V5.33333H23.499V0L28.8324 5.33333Z",
    fill: "#C2CDDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8324 5.33333H29.0824V5.22977L29.0091 5.15655L28.8324 5.33333ZM28.8324 5.33333V5.58333H29.0824V5.33333H28.8324ZM23.499 5.33333H23.249V5.58333H23.499V5.33333ZM23.499 0L23.6758 -0.176777L23.249 -0.603553V0H23.499ZM28.5824 5.33333V5.33333H29.0824V5.33333H28.5824ZM28.8324 5.08333H23.499V5.58333H28.8324V5.08333ZM23.749 5.33333V0H23.249V5.33333H23.749ZM23.3222 0.176777L28.6556 5.51011L29.0091 5.15655L23.6758 -0.176777L23.3222 0.176777Z",
    fill: "#A3B2C7",
    fillOpacity: 0.28
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.833008,
    y: 16,
    width: 29.3333,
    height: 10,
    rx: 1,
    fill: "#E53325"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25746 24V18.1818H10.4393C10.8862 18.1818 11.2612 18.2652 11.5643 18.4318C11.8692 18.5985 12.0993 18.8277 12.2546 19.1193C12.4118 19.4091 12.4904 19.7386 12.4904 20.108C12.4904 20.4811 12.4118 20.8125 12.2546 21.1023C12.0974 21.392 11.8654 21.6203 11.5586 21.7869C11.2518 21.9517 10.8739 22.0341 10.4251 22.0341H8.97905V21.1676H10.283C10.5444 21.1676 10.7584 21.1222 10.9251 21.0312C11.0917 20.9403 11.2148 20.8153 11.2944 20.6562C11.3758 20.4972 11.4165 20.3144 11.4165 20.108C11.4165 19.9015 11.3758 19.7197 11.2944 19.5625C11.2148 19.4053 11.0908 19.2831 10.9222 19.196C10.7556 19.107 10.5406 19.0625 10.2773 19.0625H9.31143V24H8.25746ZM15.3775 24H13.4059V18.1818H15.4173C15.9949 18.1818 16.4911 18.2983 16.9059 18.5312C17.3226 18.7623 17.6426 19.0947 17.8661 19.5284C18.0896 19.9621 18.2013 20.4811 18.2013 21.0852C18.2013 21.6913 18.0887 22.2121 17.8633 22.6477C17.6398 23.0833 17.3169 23.4176 16.8945 23.6506C16.4741 23.8835 15.9684 24 15.3775 24ZM14.4599 23.0881H15.3263C15.7317 23.0881 16.0697 23.0142 16.3406 22.8665C16.6114 22.7169 16.815 22.4943 16.9513 22.1989C17.0877 21.9015 17.1559 21.5303 17.1559 21.0852C17.1559 20.6402 17.0877 20.2708 16.9513 19.9773C16.815 19.6818 16.6133 19.4612 16.3462 19.3153C16.0811 19.1676 15.7515 19.0938 15.3576 19.0938H14.4599V23.0881ZM19.2028 24V18.1818H22.93V19.0653H20.2567V20.6449H22.6744V21.5284H20.2567V24H19.2028Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2229_7994"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.6667,
    height: 32,
    fill: "white",
    transform: "translate(2.16602)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/PDF.6ede96606839a36d316199aace889f71.svg";
export { ForwardRef as ReactComponent };